import { render, staticRenderFns } from "./subjects-of-allegation.vue?vue&type=template&id=f228766a&scoped=true"
import script from "./subjects-of-allegation.vue?vue&type=script&lang=js"
export * from "./subjects-of-allegation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f228766a",
  null
  
)

export default component.exports